module.exports = __webpack_public_path__ + "static/media/YF53_7.0bde1bcc.jpg";